import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory, Link } from 'react-router';
import { getLocalStorageInfo } from './';
import { Paper } from '@material-ui/core';
import ConfigData from '../console_management/configData/master/components/ConfigData';

const SideNavBasedCompoent = () => {
  return (<section className="asset-tech-specs" style={{ margin: '25px 0 0 75px' }}>
    <Paper className="tech-specs-card" style={{ height: `${window.innerHeight - 90}px` }}>
      <ConfigData />
      <div style={{ position: 'relative' }}>
        <div style={{ position: 'fixed', top: '50%', left: '58%', transform: 'translate(-50%, -58%)', color: '#000000', textAlign: 'center' }}>
          <br /><br />
          Sorry, You do not have access to the Page.<br />
          Please contact to Acumen for access <Link to="/assets-listing">Go Back</Link>
        </div>
      </div>
    </Paper>
  </section>)
}

const RoleBasedCompoent = () => {
  return (<div style={{ width: '100wh', height: '100vh', position: 'relative' }}>
    <div style={{ position: 'fixed', top: '50%', left: '58%', transform: 'translate(-50%, -58%)', color: '#000000', textAlign: 'center' }}>
      <br /><br />
      Sorry, You do not have access to the Page.<br />
      Please contact to Acumen for access <Link to="/assets-listing">Go Back</Link>
    </div>
  </div>)
}

function RoleBasedAccess(ComposedComponent, extraInfo, isSidenavBased = false) {  class authorizedUser extends Component {
    constructor(props) {
      super(props);
    }
    componentWillMount() {
      let userDetail = JSON.parse(localStorage.getItem('userInfo'));
      if (userDetail && userDetail.defaultLessor == undefined) {
        browserHistory.push("/login");
      }
    }
    render() {
      let permissionInfo1 = getLocalStorageInfo()?.user?.permission || {};
      if (permissionInfo1 && permissionInfo1[extraInfo[0]] && permissionInfo1[extraInfo[0]][extraInfo[1]] && permissionInfo1[extraInfo[0]][extraInfo[1]].indexOf(extraInfo[2]) != -1) {
        return (<ComposedComponent {...this.props} />)
      } else {
        let sideBar;
        if (isSidenavBased) {
          return (
            <SideNavBasedCompoent />
          )
        } else {
          return <RoleBasedCompoent />
        }
      }
    }
  }
  return connect(null, null)(authorizedUser);
}
export default RoleBasedAccess;
